import app from './app';
import { QUOTE_SERVICE_URL } from '../../libs/constants';

export const createQuoteSummary = requestData => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "createQuoteSummary"
        }
    };

    await api.post(QUOTE_SERVICE_URL + "/summary", requestData, headerConfig)
    .then(response => {
        if (response.data.quotationId) {
            dispatch({
                type: "SET_QUOTE_SUMMARY",
                data: response.data
            });
        }
        else {            
            dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
        }
        dispatch(app.setLoading(false));
    })    
    .catch(error => {   
        dispatch(app.setLoading(false));        
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        console.log(error);
    });
};

export const updateQuotation = (requestData, quotationId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "updateQuotation"
        }
    };

    await api.post(QUOTE_SERVICE_URL + "/updateQuotation/" + quotationId, requestData, headerConfig)
    .then(response => {
        if (response.data.quotationId) {
            dispatch({
                type: "SET_QUOTE_SUMMARY",
                data: response.data
            });
        }
        else {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
        }
        dispatch(app.setLoading(false));
    })    
    .catch(error => {   
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        console.log(error);
    });
};

export const saveQuotation = (requestData, quotationId) => async (dispatch, getState, api) => {
    dispatch(app.setLoading(true));

    const headerConfig = {
        headers: {
            "DRS-Fetch-Type": "saveQuotation"
        }
    };

    await api.post(QUOTE_SERVICE_URL, requestData, headerConfig)
    .then(response => {
        if (response.data.quoteId) {
            dispatch({
                type: "SET_QUOTE_SAVED",
                data: response.data
            });
        }
        else {
            dispatch(app.setAppModal({ type: "error", messageId: "service_error" }));
        }
        dispatch(app.setLoading(false));
    })    
    .catch(error => {   
        dispatch(app.setLoading(false));
        dispatch(app.setAppModal({ type: "error", messageId: "service_error", messageText: error?.response?.data?.message || '' }));
        console.log(error);
    });
};

const quoteActions = {
    createQuoteSummary,
    updateQuotation,
    saveQuotation
}

export default quoteActions;